import { useQuery } from '@apollo/client'
import {
  UsStateDatabaseDocument,
  UsStateDatabaseQueryVariables,
} from '@generatedTypes/graphql'

export const useUSStateDatabase = (
  options?: UsStateDatabaseQueryVariables | undefined,
) => {
  const { data, loading } = useQuery(UsStateDatabaseDocument, {
    variables: options,
  })

  const states = data?.usLocations?.states ?? []

  return {
    statesLoading: loading,
    states,
  }
}
